import { signal } from "@preact/signals";

export type ToastType = "success" | "error" | "info";

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  duration: number;
}

let nextId = 0;

export const toasts = signal<Toast[]>([]);

function addToast(type: ToastType, message: string, duration: number): string {
  const id = `toast-${++nextId}`;
  toasts.value = [...toasts.value, { id, type, message, duration }];
  setTimeout(() => dismissToast(id), duration);
  return id;
}

export function dismissToast(id: string): void {
  toasts.value = toasts.value.filter((t) => t.id !== id);
}

export const toast = {
  success: (message: string) => addToast("success", message, 4000),
  error: (message: string) => addToast("error", message, 6000),
  info: (message: string) => addToast("info", message, 4000),
};
